<template>
  <qx-card :noTitle="true">
    <BankcardDialog ref="bankcardDialog" />
    <RechargeDialog ref="rechargeDialog" />
    <h2 class="title">
      账户余额共（元）：
      <span class="error totalAmount">{{totalAmount / 100}}</span>
    </h2>
    <qx-detail-box v-for="item in accountDataList" :data="item" :key="item.key">
      <!-- 余额 -->
      <section class="clearPa" slot="totalBalance" slot-scope="prop">
        <article class="left error">{{prop.data.totalBalance !==undefined ? (prop.data.totalBalance / 100) : '--'}}</article>
        <article class="right">
          <!-- 暂时屏蔽支付相关的操作 -->
          <!-- <span class="primary btn cur" @click="showRechargeDialog(prop.data)">充值</span>
          <span
            v-if="checkPermpisions('1000002')"
            class="primary btn cur"
            @click="toWithdraw(item)"
          >提现</span> -->
          <span class="primary btn cur" @click="showBankcardDialog(prop.data)">明细</span>
          <!-- <span class="primary btn cur" @click="toChangeMoney(item)">资金互转</span> -->
          <!-- 暂时屏蔽支付相关的操作 end -->
          <qx-tips content="将收款公户的资金转入付款公户或将付款公户的资金转入收款公户" />
        </article>
      </section>
      <!-- 余额 end -->
      <!-- 收款公户 -->
      <section slot="receAmount" class="error" slot-scope="prop">{{prop.data.receAmount !== undefined ? (prop.data.receAmount / 100) : '--'}}</section>
      <!-- 收款公户 end -->
      <!-- 付款公户 -->
      <section slot="payAmount" class="error" slot-scope="prop">{{prop.data.payAmount !==undefined ? (prop.data.payAmount / 100) : '--'}}</section>
      <!-- 付款公户 end -->
    </qx-detail-box>
  </qx-card>
</template>

<script>
import {
  companyPlatformAccountList,
} from 'api/getPay';
import BankcardDialog from './bankcardDialog';
import RechargeDialog from './rechargeDialog';
export default {
  components: {
    BankcardDialog,
    RechargeDialog,
  },
  data () {
    return {
      totalAmount: 0,
      accountDataList: {
        public: {
          key: 'public',
          label: '对公账户(元)',
          tableData: {
            title: [
              {
                prop: 'totalBalance',
                label: '余额(元)',
                width: '100%',
                slot: true,
              },
              {
                prop: 'receAmount',
                label: '收款公户(元)',
                slot: true,
                width: '50%',
              },
              {
                prop: 'payAmount',
                label: '付款公户(元)',
                slot: true,
                width: '50%',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
        private: {
          key: 'private',
          label: '对私账户(元)',
          tableData: {
            title: [
              {
                prop: 'totalBalance',
                label: '余额(元)',
                width: '100%',
                slot: true,
              },
              {
                prop: 'receAmount',
                label: '收款公户(元)',
                slot: true,
                width: '50%',
              },
              {
                prop: 'payAmount',
                label: '付款公户(元)',
                slot: true,
                width: '50%',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
      },
    };
  },
  methods: {
    showRechargeDialog (item) { // 充值
      this.$refs.rechargeDialog.show(item);
    },
    showBankcardDialog (item) { // 明细
      this.$refs.bankcardDialog.show(item);
    },
    toWithdraw (item) { // 提现
      this.jump({
        label: (item.key === 'public' ? '对公' : '对私') + '账户提现',
        url: '/manage/getPay/account/platform/withdraw?type=' + item.key,
        full: true,
      });
    },
    toChangeMoney (item) { // 资金互转
      this.jump({
        label: (item.key === 'public' ? '对公' : '对私') + '账户资金互转',
        url: '/manage/getPay/account/platform/changeMoney?type=' + item.key,
        full: true,
      });
    },
  },
  async created () {
    this.totalAmount = 0;
    // 对公账户
    const publicRes = await companyPlatformAccountList({
      bankType: 111,
      isNeedHa: 0,
      userType: 6,
    });
    const publicData = {
      listData: publicRes.items,
      totalBalance: 0,
      payAmount: 0, // 收款账户余额
      receAmount: 0, // 付款方付款账户余额
    };
    publicRes.items.forEach((item) => {
      publicData.totalBalance += item.payAmount + item.receAmount;
      publicData.payAmount += item.payAmount;
      publicData.receAmount += item.receAmount;
    });
    this.accountDataList.public.tableData.data = publicData;
    const privateRes = await companyPlatformAccountList({
      bankType: 222,
      isNeedHa: 0,
      userType: 6,
    });
    const privateData = {
      listData: privateRes.items,
      totalBalance: 0,
      payAmount: 0, // 收款账户余额
      receAmount: 0, // 付款方付款账户余额
    };
    privateRes.items.forEach((item) => {
      privateData.totalBalance += item.payAmount + item.receAmount;
      privateData.payAmount += item.payAmount;
      privateData.receAmount += item.receAmount;
    });
    this.accountDataList.private.tableData.data = privateData;
    this.totalAmount = publicData.totalBalance + privateData.totalBalance;
  },
};
</script>

<style scoped lang="scss">
.title {
  height: 32px;
  padding-top: 8px;
  padding-bottom: 28px;
  border-bottom: 1px solid #e0e0e0;
  .totalAmount {
    font-size: 32px;
  }
}
.btn {
  margin-left: 16px;
}
</style>
